import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import SuperAdminSidebar from "./SuperAdminSidebar";
import SuperAdminNavbar from "./SuperAdminNavbar";

const SuperAdminLayout = () => {
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SuperAdminSidebar></SuperAdminSidebar>
        <div className="layout-page">
          <SuperAdminNavbar></SuperAdminNavbar>
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Outlet />
            </div>
            <Footer></Footer>
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default SuperAdminLayout;
